<template>
    <div>
        <div class="c-modal__wrap row">
            <simulation-property-input
                v-for="(row, index) of data"
                @reload="loadSimulationProperties"
                v-bind:key="`property${index}`"
                v-bind:dom-id="`property${index}`"
                v-bind:value="row.value"
                v-bind:property="row.property"
                v-bind:type="translateType(row.type)"
                v-bind:sim-id="getSimId">
            </simulation-property-input>
        </div>
    </div>
</template>
<script>

    import loadSimId from "../mixins/loadSimId";
    import SimulationPropertyInput from "./simulationPropertyInput";
    export default {
        name: "propertiesForm",
        components: {SimulationPropertyInput},
        mixins: [loadSimId],
        data() {
            return {
                data: [],
                simId: null,
            }
        },
        methods: {
            async getSimulationProperties(){
                const simId = this.simId;
                return this.$store.dispatch('callApi', {
                    name: 'getSimulationProperties',
                    payload: {simId}
                });
            },
            async loadSimulationProperties(){
                const data = await this.getSimulationProperties();
                this.$set(this, 'data', data);
            },
            translateType(type){
                switch (type) {
                    case 'number':
                        return 'number';
                    case 'datetime':
                        return 'datetime-local';
                    case 'gps':
                        return 'gps';
                    default:
                        return 'text';
                }
            },
        },

        computed: {
            getSimId() {
                if (this.$route.params.simId === undefined) {
                    return parseInt(this.$store.state.simId);
                } else {
                    return parseInt(this.$route.params.simId);
                }
            }
        },


        async created(){
            this.loadSimId();
            await this.loadSimulationProperties();

        }
    }
</script>

<style scoped>

</style>
